import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.3s ease;
`;

export const ModalContainer = styled.div`
  background: #1e1e1e;
  width: 600px;
  max-width: 90%;
  border-radius: 12px;
  border: 1px solid rgba(230, 170, 58, 0.3);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.3s ease;
  overflow: hidden;
`;

export const Header = styled.div`
  background: rgba(230, 170, 58, 0.1);
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    color: #c0392b;
  }
`;

export const Content = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 80vh;
  overflow-y: auto;
`;

export const InfoGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    text-transform: uppercase;
    font-weight: bold;
  }

  span {
    font-size: 16px;
    color: #fff;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 10px 0;
`;

export const ValueEditor = styled.div`
  background: rgba(0, 0, 0, 0.3);
  padding: 15px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;

  label{
  color: white
  }
`;

export const ValueDisplay = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .value {
    font-size: 24px;
    font-weight: bold;
    color: #2ecc71;
  }
`;

export const EditButton = styled.button`
  background: #e6aa3a;
  color: #111;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    opacity: 0.9;
  }
`;

export const EditForm = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  input {
    flex: 1;
    background: #111;
    border: 1px solid #e6aa3a;
    color: #fff;
    padding: 10px;
    border-radius: 4px;
    font-size: 16px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 10px;

  button {
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    border: none;
  }

  .save {
    background: #27ae60;
    color: white;
  }

  .cancel {
    background: #c0392b;
    color: white;
  }
`;
